<input
    [type]="'search'"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [required]="required"
    [value]="value"
    (input)="valueChange.emit($event.target.value)"
/>
<mat-icon svgIcon="search"></mat-icon>
